import { ContractType } from "./Schemas/ContractType";

export const contractKeys = ['car', 'life', 'property', 'travel'] as const;

export type ContractKey = typeof contractKeys[number];

export type ContractTypes = Record<ContractKey, ContractType>;

export const contractTypes: ContractTypes = {
    car: {
        title: 'Poistenie motorového vozidla',
        shortTitle: 'Mot. vozidlo',
        shortTitlePlural: 'Mot.vozidlá',
        icon: 'directions_car',
        sectorIds: [2, 4],
        filePrefix: 'C',
    },
    life: {
        title: 'Životné poistenie',
        shortTitle: 'Život',
        shortTitlePlural: 'Život',
        icon: 'favorite',
        sectorIds: [5, 6, 7, 8, 10],
        filePrefix: 'L',
    },
    property: {
        title: 'Poistenie majetku',
        shortTitle: 'Majetok',
        shortTitlePlural: 'Majetok',
        icon: 'domain',
        sectorIds: [1, 3, 11, 12, 13, 14],
        filePrefix: 'P',
    },
    travel: {
        title: 'Cestovné poistenie',
        shortTitle: 'Cestovanie',
        shortTitlePlural: 'Cestovanie',
        icon: 'work',
        sectorIds: [9],
        filePrefix: 'T',
    },
};